import { LoyaltyCashflowRequest } from '../dataType/loyalty';
import client from "./apiConfig";

export default {
  async getListCashflow(page: number, size: number, param?: LoyaltyCashflowRequest) {
    const url = `/loyalty/cashflow?page=${page}&size=${size}&customer_id=${param?.customer_id}&cashflow_type=${param?.cashflow_type}&source_type=${param?.source_type}&from_time=${param?.from_time}&to_time=${param?.to_time}`;
    const response = await client.get(url);
    return response.data;
  },
}